import BidsOffers from './BidsOffers';

export default BidsOffers;
